module.exports = __webpack_public_path__ + "static/media/img_iot.ef1e0b07.svg";


//////////////////
// WEBPACK FOOTER
// ./src/statics/images/img_iot.svg
// module id = 1067
// module chunks = 0